import { Fragment } from 'react';
import { VTStructureAnomalyData } from '../../../../utils/models';
import { getVTStructureColumns } from '../../../../utils/data';

import AutTable from '../../../blocks/aut-grid-table';
import VTStructureAnomalyItem from '../../../forms/vt/vtStructureAnomalyItem';

interface VTPEquipmentSummaryProps {
	anomalyData: VTStructureAnomalyData[];
	onDataChange: (items: VTStructureAnomalyData[]) => void;
}

const VTStructureSummary = (props: VTPEquipmentSummaryProps) => {
	const onAddItem = (item: VTStructureAnomalyData) => {
		const newAnomalyData = [...props.anomalyData];
		newAnomalyData.push({ ...item, id: props.anomalyData.length + 1 });

		props.onDataChange(newAnomalyData);
	};

	const onDeleteItem = (item: VTStructureAnomalyData): void => {
		const newAnomalyData: VTStructureAnomalyData[] = props.anomalyData.filter(
			(i) => i.id !== item.id
		);
		props.onDataChange(newAnomalyData);
	};

	return (
		<Fragment>
			<VTStructureAnomalyItem onAdd={onAddItem} />

			<div className="divider my-4"></div>

			<AutTable
				data={props.anomalyData}
				tableColumns={getVTStructureColumns()}
				onDeleteItem={onDeleteItem}
			/>
		</Fragment>
	);
};

export default VTStructureSummary;
